import {
  SearchResultType,
  SearchResult,
  RenewalStatus,
} from "@covertree/agent-portal-graphql";

import { mapRenewalStatus } from "@utils/mapRenewalStatus";
import { mapPolicyStatus } from "@utils/mapPolicyStatus";
import { mapQuoteStatus } from "@utils/mapQuoteStatus";

export const filterPolicies = (result?: SearchResult) =>
  result?.searchResultType === SearchResultType.Policy;

export const filterRenewals = (result?: SearchResult) =>
  result?.searchResultType === SearchResultType.Renewal;

export const filterQuotes = (result?: SearchResult) =>
  result?.searchResultType === SearchResultType.Quote;

export const filterSequoiaQuotes = (result?: SearchResult) =>
  result?.searchResultType === SearchResultType.Sequoia;

export const mapSearchResultStatus = (result: SearchResult) => {
  switch (result.searchResultType) {
    case SearchResultType.Renewal:
      return mapRenewalStatus(result.status as RenewalStatus);
    case SearchResultType.Quote:
    case SearchResultType.Sequoia:
      return mapQuoteStatus(result.quoteStatus);
    default:
      return mapPolicyStatus(result.status);
  }
};
